export function ImgPieChart({ style, size = 20 }: { style?: React.CSSProperties; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M10 2a8 8 0 1 0 8 8h-8V2Z" fill="currentColor" opacity=".35"/>
      <path d="M12 2.27A8.004 8.004 0 0 1 18 10h-6V2.27Z" fill="currentColor"/>
      <path d="M10 2v8h8a8 8 0 1 1-8-8Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
    </svg>
  );
}
